/* ============================================================
   Mybibblio — product card image carousel (shop page)

   Each card holds front / hardback / paperback / back images for
   both art styles (Pixar / Flat).
   • The card rests on the HARDBACK photo ("book on the table") of the
     selected art style, falling back to the front cover.
   • Desktop: the card's ◀ ▶ arrows step photo → cover art → back blurb.
   • Mobile: the slides become a scroll-snap strip (see mybibblio.css),
     filtered to the active style, with position dots.
   • The shop's Pixar/Flat toggle switches every card back to the photo.

   Display is done by toggling `.mb-on` (opacity) on the stacked
   slides — see `.card-gallery.mb-cf` in mybibblio.css. We take over
   the theme slideshow arrows entirely (the theme's own slide nav is
   a no-op because the slides are grid-stacked, not a scroll track).

   Classification is by the image's alt + filename:
     • back cover  → alt contains "Back cover" (or file has blurb/back-cover)
     • edition     → alt contains "Hardback/Paperback edition"
     • art style   → alt/filename contains "pixar" or "flat"
   ============================================================ */
(function () {
  var stylePref = 'pixar';           // 'pixar' | 'flat' — resting style from the shop toggle
  var records = [];

  function hints(img) {
    if (!img) return '';
    return (
      (img.getAttribute('alt') || '') + ' ' +
      (img.getAttribute('src') || '') + ' ' +
      (img.currentSrc || '') + ' ' +
      (img.getAttribute('srcset') || '') + ' ' +
      (img.getAttribute('data-srcset') || '')
    ).toLowerCase();
  }

  // Build { pixar: {front, back}, flat: {front, back} } from a card's slides.
  function classify(gallery) {
    var slides = [].slice.call(gallery.querySelectorAll('slideshow-slide'));
    var map = { pixar: {}, flat: {} };
    slides.forEach(function (s) {
      var h = hints(s.querySelector('img'));
      if (!h) return;
      var style = h.indexOf('pixar') > -1 ? 'pixar' : (h.indexOf('flat') > -1 ? 'flat' : null);
      if (!style) return;
      var isBack =
        h.indexOf('back cover') > -1 ||
        h.indexOf('back-cover') > -1 ||
        h.indexOf('back_cover') > -1 ||
        h.indexOf('blurb') > -1;
      var isEdition = h.indexOf('hardback') > -1 || h.indexOf('paperback') > -1 || h.indexOf('edition') > -1;
      // tag every slide so the mobile swipe strip can filter by art style
      s.setAttribute('data-mb-style', style);
      s.setAttribute('data-mb-kind', isBack ? 'back' : (isEdition ? 'edition' : 'front'));
      if (isEdition) {
        // the hardback "book on the table" photo is the card's resting image
        if (h.indexOf('hardback') > -1) {
          s.setAttribute('data-mb-fmt', 'hardback');
          if (!map[style].hero) map[style].hero = s;
        }
        return;                                       // never front/back candidates
      }
      var face = isBack ? 'back' : 'front';
      if (!map[style][face]) map[style][face] = s;   // first match wins
    });
    return map;
  }

  // faces the desktop arrows step through, in order; missing ones are skipped
  var FACES = ['hero', 'front', 'back'];
  function facesFor(rec) {
    var m = rec.map[stylePref] || {};
    return FACES.filter(function (f) { return !!m[f]; });
  }

  function render(rec) {
    var m = rec.map;
    var target =
      (m[stylePref] && (m[stylePref][rec.face] || m[stylePref].hero || m[stylePref].front)) ||
      (m.pixar && (m.pixar.hero || m.pixar.front)) ||
      (m.flat && (m.flat.hero || m.flat.front)) || null;
    rec.slides.forEach(function (s) { s.classList.toggle('mb-on', s === target); });
    var hasBack = !!(m[stylePref] && m[stylePref].back);
    rec.el.classList.toggle('mb-has-back', hasBack);
    rec.el.classList.toggle('mb-on-back', hasBack && rec.face === 'back');
    rec.el.setAttribute('data-mb-active', stylePref);
    syncDots(rec, true);
  }

  /* ---- mobile swipe dots -------------------------------------------------
     On phones the strip is a native scroll-snap carousel (see mybibblio.css);
     these dots show position within the ACTIVE style's slides. Failure here
     must never break the card, so everything is guarded. */
  function activeSlides(rec) {
    return rec.slides.filter(function (s) { return s.getAttribute('data-mb-style') === stylePref; });
  }
  function syncDots(rec, rebuild) {
    try {
      var scroller = rec.el.querySelector('slideshow-slides');
      if (!scroller) return;
      var slides = activeSlides(rec);
      var holder = rec.el.querySelector('.mb-swipe-dots');
      if (!holder) {
        holder = document.createElement('span');
        holder.className = 'mb-swipe-dots';
        holder.setAttribute('aria-hidden', 'true');
        rec.el.appendChild(holder);
        scroller.addEventListener('scroll', function () {
          if (rec.__mbDotRaf) return;
          rec.__mbDotRaf = requestAnimationFrame(function () {
            rec.__mbDotRaf = null;
            syncDots(rec, false);
          });
        }, { passive: true });
      }
      if (rebuild) {
        holder.innerHTML = '';
        for (var i = 0; i < slides.length; i++) holder.appendChild(document.createElement('i'));
        if (scroller.scrollLeft) scroller.scrollLeft = 0;   // style switch -> back to the front cover
      }
      var w = scroller.clientWidth || 1;
      var idx = Math.max(0, Math.min(slides.length - 1, Math.round(scroller.scrollLeft / w)));
      for (var j = 0; j < holder.children.length; j++) {
        holder.children[j].className = j === idx ? 'on' : '';
      }
    } catch (e) {}
  }

  function bind(gallery) {
    if (!gallery || gallery.dataset.mbCycle === '1') return;
    var map = classify(gallery);
    if (!map.pixar.front && !map.flat.front && !map.pixar.back && !map.flat.back) return;
    gallery.dataset.mbCycle = '1';
    gallery.classList.add('mb-cf');
    var rec = {
      el: gallery,
      map: map,
      slides: [].slice.call(gallery.querySelectorAll('slideshow-slide')),
      face: 'hero'
    };
    gallery.__mbRec = rec;
    records.push(rec);
    render(rec);
  }

  // step through photo → cover art → back blurb (and back again)
  function flip(rec, dir) {
    if (!rec) return;
    var faces = facesFor(rec);
    if (faces.length < 2) return;
    var i = faces.indexOf(rec.face);
    if (i < 0) i = 0;
    rec.face = faces[(i + (dir < 0 ? faces.length - 1 : 1)) % faces.length];
    render(rec);
  }

  // Take over the card arrows instead of the theme's slide nav.
  document.addEventListener('click', function (e) {
    var ctrl = e.target.closest && e.target.closest('.card-gallery.mb-cf .slideshow-control');
    if (!ctrl) return;
    var gallery = ctrl.closest('.card-gallery');
    var rec = gallery && gallery.__mbRec;
    if (!rec) return;
    e.preventDefault();
    e.stopImmediatePropagation();     // stop theme slideshow nav AND the card link navigation
    flip(rec, /previous/.test(ctrl.className) ? -1 : 1);
  }, true);

  function setStyle(style) {
    stylePref = style === 'flat' ? 'flat' : 'pixar';
    records.forEach(function (rec) { rec.face = 'hero'; render(rec); });
  }

  function bindToggles(root) {
    (root || document).querySelectorAll('[data-mb-style-toggle]').forEach(function (t) {
      if (t.dataset.mbBound === '1') return;
      t.dataset.mbBound = '1';
      t.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mb-style]');
        if (!btn) return;
        var style = btn.getAttribute('data-mb-style');     // 'pixar' | 'flat'
        t.querySelectorAll('[data-mb-style]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        t.setAttribute('data-active', style);
        setStyle(style);
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.card-gallery').forEach(bind);
    bindToggles(root);
  }

  function start() {
    init();
    try {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var nodes = muts[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('card-gallery')) bind(n);
            if (n.querySelectorAll) n.querySelectorAll('.card-gallery').forEach(bind);
            bindToggles(n.parentNode || document);
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
